
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-penilik/tim-kinerja/perencanaan/daftar-penilik/belum-diajukan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-penilik/tim-kinerja/perencanaan/daftar-penilik/belum-diajukan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-penilik/tim-kinerja/perencanaan/daftar-penilik/belum-diajukan"])
      });
    }
  